import React from 'react';
import PropTypes from 'prop-types';

const FaceSilence = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <g id="face--silence" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
        <path d="M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M12,23.1111111 C18.1364972,23.1111111 23.1111111,18.1364972 23.1111111,12 C23.1111111,5.86350278 18.1364972,0.888888889 12,0.888888889 C5.86350278,0.888888889 0.888888889,5.86350278 0.888888889,12 C0.888888889,18.1364972 5.86350278,23.1111111 12,23.1111111 Z M5.89379053,17.3179249 C5.65684048,17.381997 5.41281383,17.2418517 5.34874176,17.0049016 C5.28466969,16.7679516 5.42481498,16.5239249 5.66176503,16.4598529 C7.89023313,15.8572678 10.0565767,15.5555556 12.1601469,15.5555556 C14.2667533,15.5555556 16.3304138,15.8581524 18.3497738,16.4631408 C18.584908,16.5335856 18.7184151,16.7813063 18.6479703,17.0164405 C18.5775255,17.2515747 18.3298048,17.3850818 18.0946706,17.314637 C16.1580611,16.7344402 14.1803381,16.4444444 12.1601469,16.4444444 C10.1369196,16.4444444 8.04835047,16.7353248 5.89379053,17.3179249 Z" id="Combined-Shape" fill={color} fillRule="nonzero"></path>
      </g>
    </svg>
  );
}

FaceSilence.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

FaceSilence.defaultProps = {
  color: '#000000',
  width: 24,
  height: 24,
};

export default FaceSilence;



// WEBPACK FOOTER //
// ./src/components/Icons/FaceSilence.jsx